/**
 * Custom hook for business profile operations
 * Uses the unified 'businesses' table
 */

import { useQuery, useMutation } from 'convex/react';
import { api } from '../../convex/_generated/api';
import type { Id } from '../../convex/_generated/dataModel';
import type { IBusinessProfileFormData } from '../@types/business';

/**
 * Hook to manage business profile data and operations
 * Uses the unified businesses table via compatibility queries
 */
export function useBusinessProfile() {
  // Query current user's business profile from unified businesses table
  const profile = useQuery(api.businesses.queries.getMyBusinessProfile, {});

  // Mutations - using unified businesses table
  const updateBusiness = useMutation(api.businesses.mutations.updateBusiness);

  // Derived state
  const isLoading = profile === undefined;
  const hasProfile = profile !== null && profile !== undefined;
  const notFound = profile === null;

  /**
   * Update existing business profile
   */
  const handleUpdate = async (
    businessId: Id<'businesses'>,
    data: Partial<IBusinessProfileFormData>
  ) => {
    await updateBusiness({
      businessId,
      ...data,
    });
  };

  return {
    // Data
    profile,
    isLoading,
    hasProfile,
    notFound,

    // Operations
    updateProfile: handleUpdate,
  };
}
